import axios from 'axios';

export function uploadFileToAwsS3(url, file, headers, progress) {
  const {Host, ...filteredHeaders} = headers;
  return axios.put(url, file, {
    cancelToken: '',
    headers: filteredHeaders,
    onUploadProgress: ({loaded, total}) => {
      if (progress && total && (loaded || loaded === 0)) {
        progress(loaded / total);
      }
    },
  });
}
